import { BrowserRouter } from 'react-router-dom';
import { Providers } from '@/app/Providers';
import { AppRouter } from '@/app/router';

export default function App() {
  return (
    <BrowserRouter>
      <Providers>
        <AppRouter />
      </Providers>
    </BrowserRouter>
  );
}
